module.exports = __webpack_public_path__ + "static/img/icon-ens-item3.16449cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-ens-item3.png
// module id = RL+9
// module chunks = 21